import React from 'react';
import styled from '@emotion/styled';

import { getPercentage } from '~/App/Components/ProgressBar';
import { assetUrl } from '~/helpers';
import { FeatureDecisions } from '~/react-hooks/use-features';
import { useTranslation } from 'react-i18next';

declare global {
  interface Window {
    config: {
      features: FeatureDecisions;
      openTokApiKey: string;
    };
  }
}

export type FullWidthProgressBarProps = {
  stepsCount: number;
  currentStep: number;
  showBonjoroBadge?: boolean;
  onBonjoroBadgeClick?: () => void;
};

const ProgressBar = styled.div<{ width: string }>`
  width: ${(props) => props.width}!important;
`;

export default function FullWidthProgressBar({
  stepsCount,
  currentStep,
  showBonjoroBadge = true,
  onBonjoroBadgeClick,
}: FullWidthProgressBarProps) {
  const { t } = useTranslation();

  return (
    <div className='w-full flex h-8 md:!flex'>
      {showBonjoroBadge && (
        <div
          className='flex bg-yellow cursor-pointer'
          onClick={onBonjoroBadgeClick}
        >
          <img
            src={assetUrl('assets/images/badges/powered-by-bj.svg')}
            className='w-24 h-6 m-auto'
          />
        </div>
      )}
      <div className='w-full bg-neutral-200 relative'>
        <div className='w-24 m-auto font-bold text-xl z-10 absolute top-[10%] right-[calc(50%-50px)] text-center'>
          {currentStep === stepsCount
            ? t('testimonial:design.completed')
            : `${currentStep}/${stepsCount}`}
        </div>
        <ProgressBar
          width={getPercentage(currentStep, 0, stepsCount) + '%'}
          className='progress-bar !bg-blue'
        />
      </div>
    </div>
  );
}
